import { Grid } from '@material-ui/core';
import { useQuoteField } from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import { FormRowGrid, GridRowProps } from 'Quoting/components/shared/GridRow';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';
import { Map as IMap, List } from 'immutable';
import React from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import { GPLU_CHILD_TERM_LIFE_FIELD_ID, GPLUCoverageCode, GPLUCoverageDefinitionType } from '../../../PlanTemplates/GWL/gpluConstants';
import { getAmountValuePath, getGPLUBenefitScheduleBlockPropertyPaths, getGPLUUnderWritingBlockPropertyPaths } from '../PropertyPaths';

export const UnderWritingBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue, updateQuoteFieldValues} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const coverages = getQuoteFieldValue<List<IMap<string, any>>>(`benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}].coverageDefs`);

  const propertyPaths = getGPLUUnderWritingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);
  const benefitSchedulePaths = getGPLUBenefitScheduleBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const pwlCoverageIndex = coverages?.findIndex((cov: any) => cov.get('_type') === GPLUCoverageDefinitionType.WL);
  const pwlUwPaths = getGPLUUnderWritingBlockPropertyPaths(selectedPlan?.planIndex, pwlCoverageIndex);

  const situsStateCd = getQuoteFieldValue<string>('riskStateCd');

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-80c4b7a2-4de6-46cd-9f1f-bc0533929aed'},
      items: [
        {
          key: '4fc04f05-fde0-4c3d-af91-ba7f770a8c20',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Underwriting Type"
              id={propertyPaths.underwritingTypeCd}
              value={getQuoteFieldValue(propertyPaths.underwritingTypeCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.underwritingTypeCd, e.target.value)}
              dropdownVariant="AttributeValue"
              coverageCode={GPLUCoverageCode.CHILD_TERM_LIFE}
              searchKey="AbGPLUUnderwriting.underwritingTypeCd"
              disabled
              required
            />
          ),
          props: { xs: 12, sm: 6, md: 6 },
        },
        {
          key: '8c263f94-76d1-4ffb-9359-b7a9d789fd9e',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="GI Amount"
              id={propertyPaths.guaranteedIssueAmount}
              value={getQuoteFieldValue(getAmountValuePath(propertyPaths.guaranteedIssueAmount))}
              onChange={e => {
                const benefitType = getQuoteFieldValue(benefitSchedulePaths.benefitTypeCd);
                updateQuoteFieldValues([
                  {path: getAmountValuePath(propertyPaths.guaranteedIssueAmount), newValue: e.target.value},
                  benefitType === 'RangeValues' && {
                    path: getAmountValuePath(benefitSchedulePaths.benefitMaxAmount),
                    newValue: e.target.value,
                  },
                  benefitType === 'SingleValue' && {
                    path: getAmountValuePath(benefitSchedulePaths.flatBenefitAmount),
                    newValue: e.target.value,
                  },
                ]);
              }}
              formFieldId={GPLU_CHILD_TERM_LIFE_FIELD_ID.guaranteedIssueAmount}
              disabled={situsStateCd === 'PR'}
              type="number"
              adornment="money"
              required
            />
          ),
          props: { xs: 12, sm: 6, md: 6 },
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Underwriting" collapsible expanded withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
